import Vue from 'vue';
import {
  clone, cloneDeep, orderBy, findIndex,
} from 'lodash';
import api from 'src/api';
import { l } from 'src/utils/helper';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_FETCHING = 'SET_FETCHING';
export const SET_STOP_FETCHING = 'SET_STOP_FETCHING';
export const SYNC = 'SYNC';
export const SYNC_DOMAINS = 'SYNC_DOMAINS';
export const ATTACHMENT_ADD = 'ATTACHMENT_ADD';
export const ATTACHMENT_UPDATE = 'ATTACHMENT_UPDATE';
export const ATTACHMENT_REMOVE = 'ATTACHMENT_REMOVE';

const data = {
  departments: [],
  fetching: false,
  domains: [],
  totalCount: 0,
  pageSizeDefault: undefined,
  attachments: [],
};

const actions = {
  fetchDepartments({ commit }) {
    commit(SET_FETCHING);
    return api.getUnitsDepartments()
      .then((unitsDepartments) => commit(SYNC, { unitsDepartments }))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  fetchDepartmentsPagination({ commit }, { page, pageSize, moreData = false }) {
    commit(SET_FETCHING);
    return api.getUnitsDepartmentsPagination(page, pageSize)
      .then(({ unitsDepartments, totalCount, pageSize: pageSizeDefault }) => commit(SYNC, {
        unitsDepartments,
        totalCount,
        moreData,
        pageSizeDefault,
      }))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  createDepartment({ commit }, { model }) {
    return api.createDepartment(model).then((directory) => {
      commit('ADD_DEPARTMENT', directory);
    });
  },
  updateDepartment({ commit }, { id, model }) {
    return api.updateDepartment(id, model).then((directory) => {
      commit('UPDATE_DEPARTMENT', directory);
    });
  },
  removeDepartment({ commit }, id) {
    commit(SET_FETCHING, id);
    return api.deleteDepartment(id)
      .then(() => commit('REMOVE_DEPARTMENT', id))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  fetchDomains({ commit }) {
    commit(SET_FETCHING);
    return api.getAllowedDomains()
      .then((res) => commit(SYNC_DOMAINS, res))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  updateDomains(_, model) {
    return api.updateAllowedDomains(model);
  },
};

const mutations = {
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  SYNC(state, {
    unitsDepartments, totalCount, moreData, pageSizeDefault,
  }) {
    state.pageSizeDefault = pageSizeDefault || state.pageSizeDefault;
    if (moreData) {
      state.departments = state.departments.concat(cloneDeep(unitsDepartments));
    } else {
      state.departments = cloneDeep(unitsDepartments);
    }
    state.totalCount = totalCount || state.totalCount;
    mutations.SET_STOP_FETCHING(state);
  },
  SYNC_DOMAINS(state, payload) {
    state.domains = cloneDeep(orderBy(payload, 'domain'));
  },
  UPDATE_DEPARTMENT(state, directory) {
    const { id } = directory;
    const { departments } = state;
    const index = findIndex(departments, { id });
    Vue.set(departments, index, { ...departments[index], ...directory });
  },
  REMOVE_DEPARTMENT(state, id) {
    const { departments } = state;
    Vue.delete(departments, findIndex(departments, { id }));
    state.totalCount -= 1;
  },
  ADD_DEPARTMENT(state, directory) {
    state.departments.push(clone(directory));
  },
  ATTACHMENT_ADD(state, { activityId, temporaryId, attachment }) {
    if (!attachment || !activityId || !temporaryId) {
      l.error(`Attachment adding error. Activity Id is ${activityId}`);
      return;
    }
    state.attachments.push(attachment);
  },
  ATTACHMENT_UPDATE(state, { activityId, temporaryId, attachment }) {
    if (!attachment || !activityId || !temporaryId) {
      l.error(`Attachment updating error. Activity Id is ${activityId}`);
      return;
    }
    state.attachments = state.attachments.map((item) => {
      if (item.temporaryId === temporaryId) {
        return ({
          ...item,
          ...attachment,
        });
      }
      return item;
    });
  },
  ATTACHMENT_REMOVE(state, { activityId, temporaryId }) {
    if (!activityId || !temporaryId) {
      l.error(`Attachment removing error. Activity Id is ${activityId}`);
      return;
    }
    if (state.attachments.find((item) => item.temporaryId === temporaryId)) {
      state.attachments = state.attachments.filter((item) => item.temporaryId !== temporaryId);
    }
  },
  ATTACHMENTS_CLEAR(state) {
    if (state.attachments) {
      state.attachments = [];
    }
  },
};

const getters = {
  getDepartmentById(state) {
    const { departments } = state;
    return (id) => (departments[findIndex(departments, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  mutations,
  getters,
  actions,
};

export default store;
